import Client from "./client";

// Unauthenticated - no Authorization header, used by the public bug entry
// page (pages/PublicBugEntry.js) reached at /bugs/:code without logging in.

export const GetPublicBugEntryProject = (code) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/public/bugs/${code}`).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreatePublicBug = ({code, summary, description, reproductionSteps, expectedResult, actualResult, email}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/public/bugs/${code}`, {summary, description, reproductionSteps, expectedResult, actualResult, email}).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
